import { render } from "./ContentSecuritySettings.vue?vue&type=template&id=5558dac8"
import script from "./ContentSecuritySettings.vue?vue&type=script&lang=js"
export * from "./ContentSecuritySettings.vue?vue&type=script&lang=js"
script.render = render

export default script